import React__default from 'react';
import { setTestId } from '../../lib/testId.js';
import { useTranslate } from '../../lib/translate.js';
import { useQueryChildComponents } from '../base/SystemComponent.js';
import { Heading } from '../heading/Heading.js';
import '../layout/Box.js';
import '../layout/BulletList.js';
import { Column } from '../layout/Column.js';
import { Columns } from '../layout/Columns.js';
import '../layout/Hidden.js';
import { Inline } from '../layout/Inline.js';
import { Stack } from '../layout/Stack.js';
import '../layout/VisuallyHidden.js';
import { EmptyBuildingSVG } from '../svg/EmptyBuildingSVG.js';

const FallbackImage = ({ children  })=>{
    return React__default.createElement(React__default.Fragment, null, children);
};
FallbackImage.dataId = "data-hpy-web-fallback-image";
FallbackImage.displayName = "FallbackImage";
const FallbackHeading = ({ children  })=>{
    return React__default.createElement(Heading, {
        "data-hpy-web-fallback-heading": true,
        level: "3"
    }, children);
};
FallbackHeading.dataId = "data-hpy-web-fallback-heading";
FallbackHeading.displayName = "FallbackHeading";
const FallbackActions = ({ children  })=>{
    return React__default.createElement(Inline, {
        "data-hpy-web-fallback-actions": true,
        gap: 0.625,
        alignY: "center"
    }, children);
};
FallbackActions.dataId = "data-hpy-web-fallback-actions";
FallbackActions.displayName = "FallbackActions";
const Fallback = ({ children  })=>{
    const [image, filteredChildren] = useQueryChildComponents(children, [
        FallbackImage
    ]);
    const [heading, others] = useQueryChildComponents(filteredChildren, [
        FallbackHeading
    ]);
    const t = useTranslate();
    return React__default.createElement(Columns, {
        "data-hpy-web-fallback": true,
        ...setTestId("Fallback"),
        height: "fill",
        align: "center"
    }, React__default.createElement(Column, null, React__default.createElement(Stack, {
        align: "center",
        gap: 2
    }, image.length > 0 ? image : React__default.createElement(EmptyBuildingSVG, null), heading?.length > 0 ? heading : React__default.createElement(FallbackHeading, null, t("system:Fallback.empty_heading")), others)));
};
Fallback.dataId = "data-hpy-web-fallback";
Fallback.displayName = "Fallback";

export { Fallback, FallbackActions, FallbackHeading, FallbackImage };
